import React from 'react'
import Text from '../../../components/text'
import { NavLink } from 'react-router-dom'
import Flex from '../../../components/flex'
import logoImage from '../images/millennium-logo.png'
import Footer from "../footer";
import Helmet from "react-helmet";

const handleLogoClick = ()=>{
    window.open(
        'https://www.millenniumgarages.com/',
        '_blank'
    );
}

const LandingLayout = ({children}) => {

    return (
        <>
            <Helmet>
                <title>Millennium Garages - Flex Daily Account Management</title>
                <meta name="description" content="Millennium Garages - Flex Daily Account Management" />
            </Helmet>
            <div className="landing-layout-wrapper">
                <div className="landing-main-wrp">
                    <div className="logo">
                            <div onClick={handleLogoClick}>
                            <img src={logoImage} alt="Millennium Garages"/>
                            </div>
                    </div>
                    <div className="main_wrapper">
                        {children}
                    </div>
                    <Footer />
                </div>
            </div>
        </>
    )
}

export default LandingLayout